

export class DiscountType {
  public id: string;
  public discountTypeID: number;
  public name: string;
  public description: string;
  public discountNatureType: number;
  public isActive: boolean;
  public createdDate: Date;
  public updatedDate: Date;
  
}



// WEBPACK FOOTER //
// ./src/app/models/coupons/discount-type-model.ts